import React from "react";
import { Card } from "antd";
import TextureGallery from "./TextureGallery";

const LatestTextures = () => (
  <Card style={{ height: "100%", margin: "1.5em", overflow: "hidden" }}>
    <h2>Latest Textures</h2>
    <TextureGallery latestTextures />
  </Card>
);

export default LatestTextures;



// WEBPACK FOOTER //
// ./src/components/gallery/LatestTextures.js